import { useAppToast } from "@ui-seeker/app"


export default function useToast() {
    const {showToast} = useAppToast()

    return {
        showToast: {
            ...showToast
        }
    }
}